var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_454",
    "data-name": "Group 454",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.569,
    height: 131.845,
    viewBox: "0 0 131.569 131.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 131.569,
    height: 131.845,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M4.347,4.422A4.759,4.759,0,0,0,0,9.167V118.212A4.757,4.757,0,0,0,3.932,122.9L53.7,131.77a4.765,4.765,0,0,0,5.6-4.688V4.766A4.76,4.76,0,0,0,54.117.02ZM46.255,72.44c-2.049,0-3.711-2.922-3.711-6.518s1.662-6.515,3.711-6.515,3.713,2.913,3.713,6.515-1.662,6.518-3.713,6.518",
    transform: "translate(0 -0.001)",
    fill: "#024064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M341.061,179.058l-38.9-28.884v14.984H271.938v27.619h30.223v14.98Z",
    transform: "translate(-209.492 -115.689)",
    fill: "#9fd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M185.272,265.215c0,3.6,1.662,6.518,3.711,6.518s3.713-2.922,3.713-6.518-1.662-6.515-3.713-6.515-3.711,2.913-3.711,6.515",
    transform: "translate(-142.727 -199.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M298.773,59.4V22.121a3.714,3.714,0,0,0-3.707-3.715h-23.13v7.425h19.415V59.4Z",
    transform: "translate(-209.491 -14.179)",
    fill: "#054065"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M271.937,392.3v7.425h23.13a3.715,3.715,0,0,0,3.707-3.715V353.215h-7.422V392.3Z",
    transform: "translate(-209.491 -272.105)",
    fill: "#054065"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.fc8d7edae2e3759c8bf4f9ed08fbfb8e.svg";
export { ForwardRef as ReactComponent };